import { gql } from "graphql-request";

export const SearchUserHikeLists = gql`
  query SearchUserHikeLists($query: String, $page: Int, $perPage: Int) {
    searchUserHikeLists(query: $query, page: $page, perPage: $perPage) {
      id
      name
      description
      obfuscatedSlug
      publiclyVisible
      hikesCount
      shareableUrl
      images {
        id
        file {
          smUrl
        }
      }
    }
  }
`;

export const GetHikeList = gql`
  query GetHikeList($obfuscatedSlug: String!) {
    hikeList(obfuscatedSlug: $obfuscatedSlug) {
      id
      name
      description
      obfuscatedSlug
      publiclyVisible
      hikesCount
      totalDistanceMeters
      totalElevationGainMeters
      images {
        id
        file {
          lgUrl
          smUrl
        }
      }
      hikesHikeLists {
        id
        position
        notes
        hike {
          id
          name
          slug
          obfuscatedSlug
          distanceMeters
          elevationGainMeters
          difficulty
          staticMapImageUrl
          shareableUrl
          processingStatus
          mainRegion {
            name
          }
          mainCountry {
            name
            slug
          }
        }
      }
    }
  }
`;

export const UpdateHikeList = gql`
  mutation UpdateHikeList(
    $id: ID!
    $name: String
    $description: String
    $publiclyVisible: Boolean
    $imagesAttributes: [ImageAttributes!]
  ) {
    updateHikeList(
      input: {
        id: $id
        name: $name
        description: $description
        publiclyVisible: $publiclyVisible
        imagesAttributes: $imagesAttributes
      }
    ) {
      hikeList {
        id
        name
        description
        publiclyVisible
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const AddHikeToList = gql`
  mutation AddHikeToList(
    $hikeListId: ID!
    $hikeId: ID!
    $position: Int
    $notes: String
  ) {
    addHikeToList(
      input: {
        hikeListId: $hikeListId
        hikeId: $hikeId
        position: $position
        notes: $notes
      }
    ) {
      hikeList {
        id
        hikesCount
      }
      hikesHikeList {
        id
        position
        notes
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const RemoveHikeFromList = gql`
  mutation RemoveHikeFromList($hikeListId: ID!, $hikeId: ID!) {
    removeHikeFromList(input: { hikeListId: $hikeListId, hikeId: $hikeId }) {
      hikeList {
        id
        hikesCount
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

// Every list of the signed-in user, for the "Hike lists" map overlay's picker and
// paint. The lines themselves come from the get_user_hike_list_hikes vector-tile
// source. Paged with searchUserHikeLists' 100-per-page cap.
export const GetHikeListsForOverlay = gql`
  query GetHikeListsForOverlay($page: Int, $perPage: Int) {
    searchUserHikeLists(page: $page, perPage: $perPage) {
      id
      name
      hikesCount
    }
  }
`;
